import { render, staticRenderFns } from "./BenefitsDetail.vue?vue&type=template&id=6c6c93a2"
import script from "./BenefitsDetail.vue?vue&type=script&lang=js"
export * from "./BenefitsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports